<template>
  <div class="perf-order-nchart-widget__wrapper" style="height: 100%; width: 100%;">
    <highcharts v-if="isEmptyData" style="height: 100%; width: 100%;" class="fit-highchart" :options="options" ref="highchart" />
    <!-- <div class="empty_text" v-else-if="!isEmptyData">
      <span>데이터가 없습니다.</span>
    </div> -->
  </div>
</template>

<script>
import maxBy from 'lodash/maxBy';
import { pieOptions } from '@/constants/chart-options';

import { isEmpty } from '@/utils/basic';

export default {
  name: 'WVirtualMapPieChart',
  props: {
    title: {
      type: String,
      ddfualt: '',
    },
  },
  inject: {
    themeState: {
      default: () => {},
    },
  },
  data() {
    return {
      objtypeId: '',
      options: {},
      chartData: [],
      isEmptyData: false,
      customLegendOptions: {},
    };
  },
  computed: {
    /**
     * 차트 타입에 해당하는 차트 옵션 반환
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    chartOptions() {
      return pieOptions;
    },
  },
  watch: {
    themeState: {
      deep: true,
      handler(val) {
        if (!isEmpty(val)) {
          this.setData(this.chartData);
          this.$nextTick(() => {
            this.$refs.highchart.chart.redraw();
          });
        }
      },
    },
  },
  created() {
    window.addEventListener('resize', this.onWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
  },
  methods: {
    onWindowResize() {
      this.highlight();
    },
    setData(data, objtypeId) {
      this.$nextTick(() => {
        this.objtypeId = objtypeId;
        this.isEmptyData = !isEmpty(data) && data.length > 0;
        this.chartData = data;
        if (!isEmpty(data)) {
          this.options = this.customChartOptions();
          this.options.series = [{
            data: [{
              color: '#568bd2',
              radius: '110%',
              innerRadius: '88%',
              y: data[0].value,
            }],
          }];
        }
      });
    },
    customChartOptions() {
      const chartOptions = {};
      chartOptions.plotOptions = {
        solidgauge: {
          dataLabels: {
            format: '<span style="font-size:26px; font-weight: normal;">{y}</span>',
            align: 'center',
            verticalAlign: 'middle',
            enabled: true,
            borderWidth: 0,
            color: '#666',
          },
          linecap: 'round',
          stickyTracking: false,
          rounded: true,
        },
      };
      chartOptions.chart = {
        type: 'solidgauge',
        margin: [0, 5, 20, 5],
        // height: 200,
        // width: this.objtypeId === 'VVM' ? 150 : 200,
      };
      chartOptions.tooltip = {
        enabled: false,
      };
      chartOptions.credits = {
        enabled: false,
      };
      chartOptions.title = {
        text: `<span style="font-size: 14px;">${this.title} &nbsp; <span style="font-size: 11px;">(%)</span></span>`,
        floating: false,
        align: 'center',
        style: {
          color: '#666',
        },
        useHTML: true,
        y: 180,
      };
      chartOptions.yAxis = {
        min: 0,
        max: 100,
        lineWidth: 0,
        tickPositions: [],
      };
      chartOptions.chart.spacing = [0, 0, 0, 0];
      chartOptions.pane = {
        startAngle: 0,
        endAngle: 360,
        background: [{ // Track for Move
          outerRadius: '110%',
          innerRadius: '88%',
          backgroundColor: '#f4f4f5',
          borderWidth: 0,
        }],
      };
      return chartOptions;
    },
    highlight() {
      try {
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
        }
        const data = maxBy(this.$refs.highchart.chart.series[0].data, (item) => item.y);
        data.setState('');
        this.timeoutId = setTimeout(() => {
          data.setState('hover');
        }, 500);
      } catch (e) {
        // ignore
      }
    },
    resize() {
      this.$refs.highchart.chart.reflow();
      this.highlight();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/components/virtual/VirtualMapPieChart.vue